import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white shadow container rounded-2xl py-4 justify-between items-start h-full min-h-screen" }
const _hoisted_2 = { class: "space-y-3 p-3 w-full" }
const _hoisted_3 = { class: "flex flex-row justify-between items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Activities", -1)
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-6 w-6 mr-2\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\"></path><path d=\"M12 20l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2l-3 3\"></path><line x1=\"8\" y1=\"9\" x2=\"16\" y2=\"9\"></line><line x1=\"8\" y1=\"13\" x2=\"14\" y2=\"13\"></line></svg>Leave a comment", 2)
const _hoisted_7 = [
  _hoisted_5
]
const _hoisted_8 = {
  key: 0,
  class: "py-4 animate__animated animate__fadeIn"
}
const _hoisted_9 = { class: "p-2 flex flex-col" }
const _hoisted_10 = { class: "flex justify-end space-x-2 mt-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Cancel", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Send comment", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_16 = { class: "event-cointainer" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "w-full" }
const _hoisted_19 = { class: "text-sm" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "text-sm font-semibold" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" has created the job. ")
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "text-sm font-semibold" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" edited the job. ")
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "text-sm font-semibold" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" changed the job publish date. ")
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { class: "text-sm font-semibold" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" added a comment ")
const _hoisted_32 = { key: 4 }
const _hoisted_33 = { class: "text-sm font-semibold" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" has created this job with active ")
const _hoisted_35 = /*#__PURE__*/_createElementVNode("strong", { class: "text-sm font-semibold" }, "managed services", -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_37 = { key: 5 }
const _hoisted_38 = { class: "text-sm font-semibold" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" has activated the ")
const _hoisted_40 = /*#__PURE__*/_createElementVNode("strong", { class: "text-sm font-semibold" }, "managed services", -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" to this job. ")
const _hoisted_42 = { key: 6 }
const _hoisted_43 = { class: "text-sm font-semibold" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" has deactivated the ")
const _hoisted_45 = /*#__PURE__*/_createElementVNode("strong", { class: "text-sm font-semibold" }, "managed services", -1)
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" from this job. ")
const _hoisted_47 = { key: 7 }
const _hoisted_48 = { class: "text-sm font-semibold" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" has closed this job. ")
const _hoisted_50 = { key: 8 }
const _hoisted_51 = { class: "text-sm font-semibold" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" has reopened the job. ")
const _hoisted_53 = { class: "font-light text-gray-400 text-sm italic" }
const _hoisted_54 = {
  key: 9,
  class: "italic text-gray-600 text-sm block w-full"
}
const _hoisted_55 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mentionable = _resolveComponent("Mentionable")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (!_ctx.addComment)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setAddComment(true))),
              class: "flex flex-row justify-between items-center bg-gray-50 hover:bg-gray-100 p-2 text-primary rounded-lg hover:cursor-pointer text-sm"
            }, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      (_ctx.addComment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Mentionable, {
                modelValue: _ctx.content,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.content) = $event)),
                users: _ctx.users,
                placeholder: "Use @ to mention a collaborator"
              }, null, 8, ["modelValue", "users"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearForm && _ctx.clearForm(...args))),
                  class: "flex flex-row justify-between items-center rounded-full border-2 border-primary text-primary py-3 px-4"
                }, _hoisted_12),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addJobActivityComment && _ctx.addJobActivityComment(...args))),
                  class: "flex flex-row justify-between items-center rounded-full border-2 border-primary bg-primary text-white py-3 px-4"
                }, _hoisted_14)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.jobTimeline && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobTimeline, (event, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "border-b-2",
                key: index
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: "w-full flex flex-row space-x-2 p-2 my-1 rounded-lg",
                    style: _normalizeStyle({
                'background-color': _ctx.highlightColor(event.event_type),
              })
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.buildImageStage(event.event_type),
                      alt: "",
                      class: "mr-2"
                    }, null, 8, _hoisted_17),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        (event.event_type === 'new_job')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                              _createElementVNode("strong", _hoisted_21, _toDisplayString(event.staff?.first_name) + " " + _toDisplayString(event.staff?.last_name), 1),
                              _hoisted_22
                            ]))
                          : _createCommentVNode("", true),
                        (event.event_type === 'update')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                              _createElementVNode("strong", _hoisted_24, _toDisplayString(event.staff?.first_name) + " " + _toDisplayString(event.staff?.last_name), 1),
                              _hoisted_25
                            ]))
                          : _createCommentVNode("", true),
                        (event.event_type === 'job_update_publish_date')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                              _createElementVNode("strong", _hoisted_27, _toDisplayString(event.staff?.first_name) + " " + _toDisplayString(event.staff?.last_name), 1),
                              _hoisted_28
                            ]))
                          : _createCommentVNode("", true),
                        (event.event_type === 'job_activity_comment')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                              _createElementVNode("strong", _hoisted_30, _toDisplayString(event.staff?.first_name) + " " + _toDisplayString(event.staff?.last_name), 1),
                              _hoisted_31
                            ]))
                          : _createCommentVNode("", true),
                        (event.event_type === 'managed_job_created')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                              _createElementVNode("strong", _hoisted_33, _toDisplayString(event.staff?.first_name) + " " + _toDisplayString(event.staff?.last_name), 1),
                              _hoisted_34,
                              _hoisted_35,
                              _hoisted_36
                            ]))
                          : _createCommentVNode("", true),
                        (event.event_type === 'managed_job_turned_on')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                              _createElementVNode("strong", _hoisted_38, _toDisplayString(event.staff?.first_name) + " " + _toDisplayString(event.staff?.last_name), 1),
                              _hoisted_39,
                              _hoisted_40,
                              _hoisted_41
                            ]))
                          : _createCommentVNode("", true),
                        (event.event_type === 'managed_job_turned_off')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                              _createElementVNode("strong", _hoisted_43, _toDisplayString(event.staff?.first_name) + " " + _toDisplayString(event.staff?.last_name), 1),
                              _hoisted_44,
                              _hoisted_45,
                              _hoisted_46
                            ]))
                          : _createCommentVNode("", true),
                        (event.event_type === 'job_closed')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                              _createElementVNode("strong", _hoisted_48, _toDisplayString(event.staff?.first_name) + " " + _toDisplayString(event.staff?.last_name), 1),
                              _hoisted_49
                            ]))
                          : _createCommentVNode("", true),
                        (event.event_type === 'job_reopened')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                              _createElementVNode("strong", _hoisted_51, _toDisplayString(event.staff?.first_name) + " " + _toDisplayString(event.staff?.last_name), 1),
                              _hoisted_52
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_53, " • " + _toDisplayString(_ctx.getFormattedDate(event?.created_at)), 1),
                        (event.event_type === 'job_activity_comment')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(event.sourceable?.content), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 4)
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_55, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], (item, index) => {
              return _createElementVNode("div", { key: index }, [
                _createVNode(_component_Skeleton, { option: "text" })
              ])
            }), 64))
          ]))
    ])
  ]))
}